import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ButtonType } from '../button/button.component';
import { MenuItem, SelectionEvent } from '../menu/menu.component';
import { PopupPlacement } from '../../popup/popup.component';

@Component({
  selector: 'dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent {
  @Input() buttonIcon?: string;
  @Input() buttonType?: ButtonType;
  @Input() buttonLabel?: string;
  @Input() showArrow?: boolean = true;
  @Input() menuItems: MenuItem[] = [];
  @Input() menuPlacement?: PopupPlacement;
  @Input() selectedIndex?: number;
  @Output() selection: EventEmitter<SelectionEvent> = new EventEmitter<SelectionEvent>();

  onSelection(event: SelectionEvent): void {
    this.selection.emit(event);
  }
}